module.exports = "ul {\r\n  list-style-type: none;\r\n}\r\n\r\nli {\r\n  margin-left: -25px;\r\n}\r\n\r\n.locations-list {\r\n  margin-bottom: 50px;\r\n}\r\n\r\n#more-locations-button {\r\n  margin: auto;\r\n  min-width: 200px;\r\n}\r\n\r\n#table-wrapper {\r\n  max-height: 500px;\r\n  width: 100%;\r\n  overflow-y: auto;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/select-location/select-location.component.css
// module id = ./src/app/select-location/select-location.component.css
// module chunks = main